export enum LanguageBackendType {
  GERMAN = "GERMAN",
  ENGLISH = "ENGLISH",
  FRENCH = "FRENCH",
  ITALIAN = "ITALIAN",
}

export enum LanguageFrontendType {
  de = "de_CH",
  en = "en_CH",
  fr = "fr_CH",
  it = "it_CH",
}

export enum LanguageCode {
  de = "de",
  en = "en",
  fr = "fr",
  it = "it",
}
